import { render, staticRenderFns } from "./EditWebhookModal.vue?vue&type=template&id=87d1ca94&scoped=true&lang=pug"
import script from "./EditWebhookModal.vue?vue&type=script&lang=js"
export * from "./EditWebhookModal.vue?vue&type=script&lang=js"
import style0 from "./EditWebhookModal.vue?vue&type=style&index=0&id=87d1ca94&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d1ca94",
  null
  
)

export default component.exports